export enum MultiStateInputCategory {
    ReeferInterfaceStatus = 0,
    ReeferOperatingMode = 1,
    ReeferEngineSpeedMode = 2,
    ReeferEngineMode = 3,
    ReeferZoneOperatingMode = 4
}
